export default {
  name: 'asset',
  translationKey: 'asset-module',
  routePrefix: 'asset',
  routeNamePrefix: 'asset',
  directRoutesAvailable: true,
}
